import React, { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../services/AuthService';
import { setTokenExpiry } from '../../services/UtilService';

function Redirecting() {
    const navigate = useNavigate();
    const authService = new AuthService();

    useLayoutEffect(() => {
        authService.signinRedirectCallback().then(function () {
            setTokenExpiry();
            navigate('/dashboard');
        }).catch(function (e) {
            console.error(e);
        });
    }, []);
    
    return (      
        <div>Redirecting</div>
    );
}
  
export default Redirecting;